const ROUTES = ['/messaging', '/messaging/thread/:conversation'] as const

const Label = {
	Emoji: 'Open Emoji Keyboard',
	Gif: 'Open GIF Keyboard'
}

export { Label, ROUTES }
